import { Component, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { AuthSessionRecoveryStore } from './core/auth/auth-session-recovery.store';
import { ApiContextStore } from './core/state/api-context.store';
import {
  UiButton,
  UiDialog,
  UiDialogDescription,
  UiDialogOverlay,
  UiDialogTitle,
  UiConfirmDialogOutlet,
  UiToastOutlet,
} from './shared/ui';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    UiButton,
    UiDialog,
    UiDialogDescription,
    UiDialogOverlay,
    UiDialogTitle,
    UiConfirmDialogOutlet,
    UiToastOutlet,
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  readonly sessionRecovery = inject(AuthSessionRecoveryStore);
  readonly apiContext = inject(ApiContextStore);
  private readonly router = inject(Router);

  loginAgain() {
    const returnTo = this.sessionRecovery.returnUrl();
    this.sessionRecovery.clear();
    void this.router.navigate(['/login'], {
      queryParams: { returnTo },
    });
  }
}
